// Định dạng giờ cố định 24 giờ theo giờ Việt Nam, không phụ thuộc ngôn ngữ
// của trình duyệt. `toLocaleString()` để trống locale ra "2:00:00 PM" trên máy
// cài tiếng Anh. `hourCycle: 'h23'` thay cho `hour12: false` vì một số engine
// in nửa đêm thành "24:00" với `hour12: false`.
const VUNG_GIO = 'Asia/Ho_Chi_Minh';

const dinhDang = new Intl.DateTimeFormat('en-GB', {
  timeZone: VUNG_GIO,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const tachPhan = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const p = {};
  dinhDang.formatToParts(d).forEach(({ type, value: v }) => {
    p[type] = v;
  });
  return {
    gio: `${p.hour}:${p.minute}`,
    ngay: `${p.day}/${p.month}/${p.year}`,
  };
};

// "14:00"
export const gioPhut = (value) => tachPhan(value)?.gio || '';

// "14:00 08/10/2026"
export const ngayGio = (value) => {
  const p = tachPhan(value);
  return p ? `${p.gio} ${p.ngay}` : '';
};

// "14:00 - 15:30 ngày 08/10/2026"; qua ngày thì ghi đủ ngày hai đầu.
export const khoangGio = (start, end) => {
  const a = tachPhan(start);
  const b = tachPhan(end);
  if (!a) return '';
  if (!b) return `${a.gio} ${a.ngay}`;
  if (a.ngay === b.ngay) return `${a.gio} - ${b.gio} ngày ${a.ngay}`;
  return `${a.gio} ${a.ngay} - ${b.gio} ${b.ngay}`;
};
